module.exports = __webpack_public_path__ + "media/images/icons/social/facebook-daae5fe92295cb439d924a9314c2ee49.svg";